import { runtimeEnv } from 'config/runtimeEnv';
import requestInstance from './Request';

const BASE_URL = `${runtimeEnv('B2B_API_BASE_URL')}`;

const highlightOrderService = {
  // GET: Fetch Highlights
  async getHighlights(params = {}) {
    try {
      const response = await requestInstance.get(`${BASE_URL}/admin-api/v1/highlights?isB2B=true`, {
        params,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async addToHighLight(highLightData) {
    try {
      const formData = {
        ...highLightData,
        isB2B: true,
      };
      const response = await requestInstance.post(`${BASE_URL}/admin-api/v1/highlights`, formData, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateHighLight(highLightData, id) {
    try {
      const formData = {
        ...highLightData,
        isB2B: true,
      };
      const response = await requestInstance.put(
        `${BASE_URL}/admin-api/v1/highlights/${id}`,
        formData,
        {
          headers: { 'Content-Type': 'application/json' },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async saveHighLightOrder(highLightData) {
    try {
      const payload = {
        newOrder: highLightData.newOrder || [],
        location: highLightData.location,
        isB2B: true,
      };
      const response = await requestInstance.post(
        `${BASE_URL}/admin-api/v1/highlights/reorder`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteHighLight(id) {
    try {
      const response = await requestInstance.delete(
        `${BASE_URL}/admin-api/v1/highlights/${id}?isB2B=true`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default highlightOrderService;
